
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 13.6V4.5c0-.8-.7-1.5-1.5-1.5H17V1.5c0-.8-.7-1.5-1.5-1.5h-1c-.8 0-1.5.7-1.5 1.5V3H8V1.5C8 .7 7.3 0 6.5 0h-1C4.7 0 4 .7 4 1.5V3H1.5C.7 3 0 3.7 0 4.5v16c0 .8.7 1.5 1.5 1.5h12.8c1 1.2 2.5 2 4.2 2 3 0 5.5-2.5 5.5-5.5 0-2.1-1.2-4-3-4.9zM13.6 16H11v-4h4v2.3c-.6.4-1 1-1.4 1.7zM6 16v-4h4v4H6zm4 1v4H6v-4h4zm5-10v4h-4V7h4zm-5 4H6V7h4v4zm-5 0H1V7h4v4zm0 1v4H1v-4h4zm11 0h4v1.2c-.5-.1-1-.2-1.5-.2-.9 0-1.7.2-2.5.6V12zm4-1h-4V7h4v4zm-6-9.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-2zm-9 0c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-2zM1.5 4h2.6c.2.6.8 1 1.4 1h1c.7 0 1.2-.4 1.4-1h5.2c.2.6.8 1 1.4 1h1c.7 0 1.2-.4 1.4-1h2.6c.3 0 .5.2.5.5V6H1V4.5c0-.3.2-.5.5-.5zM1 20.5V17h4v4H1.5c-.3 0-.5-.2-.5-.5zm10 .5v-4h2.2c-.1.5-.2 1-.2 1.5 0 .9.2 1.7.6 2.5H11zm7.5 2C16 23 14 21 14 18.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5z"}}),_c('path',{attrs:{"d":"M17.5 21c-.1 0-.3-.1-.4-.1l-2-2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l1.6 1.6 2.7-3.5c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-3 4c-.1 0-.2.1-.4.1z"}})])
          )
        }
      }
    